import { SiteDatasetReviewDto } from '@interfaces/central-monitoring';
import useSWR, { mutate } from 'swr';
import useSWRMutation from 'swr/mutation';
import { getData, postData, ValidationErrorResponse } from '@apis/rest-client';

const endpoints = {
    getAll: (studyId: string, siteId: number) => `CentralMonitoring/SiteDatasetReview/${studyId}/${siteId}`,
};
const SiteDatasetReviewsApi = {
    useGet: (studyRef: string, siteId?: number, datasetId?: number) => {
        const url = `CentralMonitoring/SiteDatasetReview/${studyRef}/${siteId}/${datasetId}`;

        return useSWR<SiteDatasetReviewDto, ValidationErrorResponse>(datasetId && siteId ? url : null, getData);
    },

    useGetAll: (studyRef: string, siteId?: number) => {
        return useSWR<SiteDatasetReviewDto[], ValidationErrorResponse>(
            siteId ? endpoints.getAll(studyRef, siteId) : null,
            getData,
        );
    },

    invalidateGetAll: (studyRef: string, siteId: number) => {
        return mutate(endpoints.getAll(studyRef, siteId));
    },

    useGetPreviousReviewedDatasetIds: (studyRef: string, siteId?: number, datasetId?: number) => {
        const url = `CentralMonitoring/SiteDatasetReview/${studyRef}/${siteId}/${datasetId}/previous-reviewed-datasets`;

        return useSWR<number[]>(datasetId && siteId ? url : null, getData);
    },

    useSave: (studyRef: string, siteId: number, datasetId: number) => {
        return useSWRMutation(
            `CentralMonitoring/SiteDatasetReview/${studyRef}/${siteId}/${datasetId}`,
            (url: string, { arg }: { arg: SiteDatasetReviewDto }) => {
                return postData<SiteDatasetReviewDto, NonNullable<unknown>>(url, { arg, timeout: 30000 });
            },
        );
    },
};

export default SiteDatasetReviewsApi;
